import React from 'react';
import { Box, Tooltip } from '@material-ui/core';
import { useTheme , Theme} from "@material-ui/core";


interface Status {
  timestamp: number;
  status: string;
  result: string;
}

interface StatusIndicatorProps {
  statuses: Status[];
}

const status_colors = (key: string, theme: Theme): string => {
  switch (key) {
    case 'SUCCESS':
      return theme.palette.success.main;
    case 'FAILED':
      return theme.palette.error.main;
    case 'Attention Required':
      return theme.palette.warning.main;
    case 'TECHNICAL_ERROR':
      return theme.palette.warning.main;
    default:
      return '#e0e0e0';
  }
};

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ statuses }) => {

  const theme = useTheme();

  const totalStatuses = 10;
  const filledStatuses = statuses.length;
  const emptyStatuses = totalStatuses - filledStatuses;

  // Sort statuses by timestamp in ascending order
  const sortedStatuses = [...statuses].sort((a, b) => a.timestamp - b.timestamp);

  return (
    <Box mb={4}> 
      <Box display="flex" marginTop={3.5}>
        <Box display="flex">
          {sortedStatuses.map((run, index) => (
            <Tooltip key={index} title={new Date(run.timestamp).toLocaleString()} arrow>
              <Box
                width={15}
                height={15}
                bgcolor={status_colors(run.status, theme)}
                borderRadius="20%"
                mx={0.5}
              />
            </Tooltip>
          ))}
          {Array.from({ length: emptyStatuses }).map((_, index) => (
            <Box
              key={`empty-${index}`}
              width={15}
              height={15}
              bgcolor='#e0e0e0'
              borderRadius="20%"
              mx={0.5}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default StatusIndicator;